module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-information-settings"
  }, [_c('div', {
    staticClass: "row mx-0 mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 px-0"
  }, [_c('Button', {
    attrs: {
      "disabled": false,
      "isLoading": false
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("Добавить место работы")])], 1)]), (!_vm.works.length) ? _c('div', {
    staticClass: "col-12 d-flex flex-column px-0 mb-2"
  }, [_c('h3', {
    staticClass: "profile-information-settings_type-title mb-4 mt-4"
  }, [_vm._v("Нет информации о местах работы")])]) : _vm._e(), _vm._l((_vm.works), function(work) {
    return _c('div', {
      key: work.id,
      staticClass: "row mx-0 px-3 py-3 profile-information-settings_card-item mb-3"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.region.name))])]), _vm._m(1, true), _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.partner.name || work.work_place))])]), (work.prof_sphere.name) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Сфера деятельности")])]) : _vm._e(), (work.prof_sphere.name) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.prof_sphere.name))])]) : _vm._e(), (work.site) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Сайт организации")])]) : _vm._e(), (work.site) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.site))])]) : _vm._e(), (work.position) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Должность")])]) : _vm._e(), (work.position) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.position))])]) : _vm._e(), (work.duties) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Обязанности")])]) : _vm._e(), (work.duties) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.duties))])]) : _vm._e(), (work.acceptance_date) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Дата принятия")])]) : _vm._e(), (work.acceptance_date) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.acceptance_date))])]) : _vm._e(), (work.dismissal_date) ? _c('div', {
      staticClass: "col-4 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item--bold"
    }, [_vm._v("Дата увольнения")])]) : _vm._e(), (work.dismissal_date) ? _c('div', {
      staticClass: "col-6 d-flex flex-column mb-4"
    }, [_c('span', {
      staticClass: "profile-information-settings_item"
    }, [_vm._v(_vm._s(work.dismissal_date))])]) : _vm._e(), _c('AppSvgIcon', {
      staticClass: "ui_color__red px-0 py-0 ui_cursor__pointer profile-information-settings_item-remove",
      attrs: {
        "template": _vm.$ui.IconSvgComponents.close,
        "color-mode": "stroke",
        "manual-width": "auto",
        "as-is-button": "as-is-button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(work)
        }
      }
    })], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4 d-flex flex-column mb-4"
  }, [_c('span', {
    staticClass: "profile-information-settings_item--bold"
  }, [_vm._v("Регион")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4 d-flex flex-column mb-4"
  }, [_c('span', {
    staticClass: "profile-information-settings_item--bold"
  }, [_vm._v("Место работы")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267d2566","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/work/Work.vue
// module id = f0d66632eaae2f2907ea
// module chunks = 27